import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../Services/userservice.service';
import { MustMatch } from '../registro/Validators/match.validator';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {

  formregistro: UntypedFormGroup;
  submitted = false;
  super=false;
  id:any;

  passRequirement = {
    passwordMinLowerCase: 1,
    passwordMinNumber: 1,
    passwordMinSymbol: 1,
    passwordMinUpperCase: 1,
    passwordMinCharacters: 8
  };
  pattern = [
    `(?=([^a-z]*[a-z])\{${this.passRequirement.passwordMinLowerCase},\})`,
    `(?=([^A-Z]*[A-Z])\{${this.passRequirement.passwordMinUpperCase},\})`,
    `(?=([^0-9]*[0-9])\{${this.passRequirement.passwordMinNumber},\})`,
    `(?=(\.\*[\$\@\$\!\%\*\?\&])\{${this.passRequirement.passwordMinSymbol},\})`,
    `[A-Za-z\\d\$\@\$\!\%\*\?\&\.]{${
      this.passRequirement.passwordMinCharacters
    },}`
  ].map(item => item.toString())
  .join("");

  constructor(
    private formBuilder: UntypedFormBuilder, 
    private userService: UserService, 
    private _snackBar: MatSnackBar,
    private router: Router,
    private rutaActiva: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.onPropagar();
    this.super=this.userService.is_super()

    

    if(!this.super){
      this.userService.logout()
      this.router.navigate(['login']);
      
    }


    this.formregistro = this.formBuilder.group({
      username: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      pass: ['', [
        Validators.required,
        Validators.minLength(8), 
        Validators.pattern(this.pattern)
      ]],
      confirm_pass: ['', Validators.required],
      roles: ['', Validators.required],
    });

    this.getUser();

  }


  onPropagar(){
    this.userService.emitChange("Editar usuario")
  }

  getUser(){
    this.rutaActiva.params.subscribe(params =>{
      this.id = params['id']

      const token = this.userService.getToken();
      this.userService.getUserById(this.id, token).subscribe(
        (res:any)=>{
          console.log(res);

          let user = res.data;
          if(res.ok){
            // console.log('entro aqui');
            
            this.username?.setValue(user.username)
            this.email?.setValue(user.email)
            this.roles?.setValue(user.role)
            this.pass?.setValue('')
            this.confirm_pass?.setValue('')

          }
          

        },
        (err:any)=>{
          console.log(err);
          if (err.status == 401) {
            this._snackBar.open('Lo sentimos, la sesión ha expirado', '', {
                duration: 5000,
                horizontalPosition: 'left',
                verticalPosition: 'bottom'
            })
            this.router.navigate(['login']);
            return
          }
          
        }
      )
      
    })
  }

  get f() { return this.formregistro.controls; }

  get username(){
    return this.formregistro.get('username');
  }

  get email(){
    return this.formregistro.get('email')
  }

  get roles(){
    return this.formregistro.get('roles')
  }

  get pass(){
    return this.formregistro.get('pass')
  }

  get confirm_pass(){
    return this.formregistro.get('confirm_pass')
  }


  submit(values: any) {

    this.submitted = true;

    if(this.pass.invalid){
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: `La contraseña debe contener: una longitud mayor o igual a 8 caracteres, al menos 1 dígito, al menos 1 letra mayúscula, letras minúsculas y al menos 1 carácter especial (!#$%&'()*:;?@¡)`,
      })
      this.pass.setValue('')
      this.confirm_pass.setValue('')
    
      return;

    }

    if (this.formregistro.invalid) {
      console.log(this.formregistro);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Los datos ingresador en el formulario no son validos',
      })
    
      return;
    }

    if(this.pass.value != this.confirm_pass.value) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Las contraseñas no coinciden',
      })
      this.pass.setValue('')
      this.confirm_pass.setValue('')
      return
    };

    let data = {
      id: this.id,
      username:values.username, 
      email:values.email,
      password:values.pass,
      roles:[{id:values.roles, type:"foreignid"}]
    }

    this.userService.editUser(data).subscribe(
      (res:any)=>{
        console.log(res);
        // this._snackBar.open("Usuario editado correctamente", "Cerrar");
        Swal.fire(
          'Edición de usuario',
          `Usuario ${values.username} editado correctamente`,
          'success'
        )
        this.router.navigate(['list-users'])

        
      },
      (err:any)=>{
        console.log(err);    
        if(err.status == 429){
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: err.error,
          })
          return
        }
        if (<any>err.status === 401) {
          this.router.navigate(['login']);
        }    
      }
    )


    /*this.userService.registro(data).subscribe(
      res => {
        console.log(res);
        this._snackBar.open("Usuario creado correctamente", "Cerrar");
        this.router.navigate(['list-users'])
      },
      err => {
        if(err.status == 429){
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: err.error,
          })
          return
        }
        if (<any>err.status === 401) {
          this.router.navigate(['login']);
        }
      }
    )*/

  }

}
